import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ActivateIcon, AlertIcon, DeactivateIcon } from 'assets/materialIcons/materialIcons';

class DeleteRelatedButton extends React.Component {
    state = {
        dialog: false,
    };

    handleDialogOpen = () => {
        this.setState({
            dialog: true,
        });
    };

    handleDialogClose = () => {
        this.setState({
            dialog: false,
        });
    };

    handleDialogSubmit = () => {
        const { handleRemove } = this.props;

        handleRemove();

        this.handleDialogClose();
    }

    render() {
        const { translate } = this.props;

        const actions = [
            <RaisedButton
                icon={ <AlertIcon /> }
                key='cancel'
                keyboardFocused={ true }
                label={ translate('actions.cancel') }
                onTouchTap={ this.handleDialogClose }
                style={ { marginRight: '20px' } }
            />,
            <RaisedButton
                icon={ <ActivateIcon /> }
                key='submit'
                label={ translate('actions.ok') }
                onTouchTap={ this.handleDialogSubmit }
                primary
            />,
        ];

        return (
            <div>
                <IconButton
                    onTouchTap={ this.handleDialogOpen }
                    style={ { transform: 'rotate(45deg)' } }
                >
                    <DeactivateIcon
                        color={ theme.palette.primary1Color }
                        hoverColor={ theme.palette.primary1ColorHover }
                    />
                </IconButton>

                <Dialog
                    actions={ actions }
                    actionsContainerStyle={ { padding: '0 24px 24px' } }
                    contentStyle={ { maxWidth: '600px' } }
                    modal={ false }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    onRequestClose={ this.handleDialogClose }
                    open={ this.state.dialog }
                    title={ translate('resources.products.related.delete.title') }
                >
                    { translate('resources.products.related.delete.description') }
                </Dialog>
            </div>
        );
    }
}

DeleteRelatedButton.propTypes = {
    handleRemove: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(DeleteRelatedButton);



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/buttons/DeleteRelatedButton.js